/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/7/13
 * Time: 6:59 PM
 * To change this template use File | Settings | File Templates.
 * * ********************************************************************************************************
 *
 * V1.4
 *
 * Date: 08-MAY-2013
 * Visual PDF: single_Select_ver-1.4.pdf
 *
 * This widget is used to implement a single select items filtered by category component on the page.
 * Options:
 * el: mandatory - the element in the page where the component will be displayed
 * collection: mandatory - the collection to display. type BaseCollection or Backbone.Collection
 * selectedItems: optional - selected item ids in array
 * title: mandatory - the title to be displayed in the top of the component
 * onSelect: optional - A reference to a callback function that will be called when selected item is done
 *
 * Using Example:
 *
 *
 *  js:
 *  var singleSelect = new SingleSelect({
 *      title: "Select a goal type",
 *      collection: LECampaigns.getModelsManager().getGoalTypeCollection(),
 *      selectedItems: [],
 *      el:this.ui.singleSelect,
 *      onSelect:this.goalTypeSelected ,
 *  });
 *
 *
 * *******************************************************************************************************
 *
 */
define(function (require) {
    "use strict";
    var Wreqr = require("backbone.wreqr");
    var Marionette = require("marionette");
    var Logger = require('logger');
    var SingleSelectTitleModel = require('ui/single-select/js/models/SingleSelectTitleModel');
    var SingleSelectModel = require('ui/single-select/js/models/SingleSelectModel');
    var SingleSelectCategoriesCollection = require('ui/single-select/js/collections/SingleSelectCategoriesCollection');
    var SingleSelectTitleView = require('ui/single-select/js/views/SingleSelectTitleView');
    var SingleSelectCollectionView = require('ui/single-select/js/views/SingleSelectCollectionView');
    var SingleSelectLayout = require('ui/single-select/js/views/SingleSelectLayout');
    var $ = require("jquery");
    var _ = require("underscore");

    var SingleSelectController = Marionette.Controller.extend({

        /**
         * Initialize the controller
         */
        initialize : function (options) {
            var that = this;
            that.version = '1.4';

            that.logger = Logger.getLogger("SingleSelect");

            //initialize views, collections
            this.setObjects(options);

            //render the layout
            this.render(options);
        },

        /**
         * validate options
         */
        isOptionValid: function(options){
            if (!options.collection) {
                this.logger.error("Collection to display is mandatory","SingleSelectController:isOptionValid");
                this.logger.graph({ name: "UIComponents:SingleSelectController:isOptionValid:collection"});
                return false;
            }
            if (!options.el) {
                this.logger.error("el for SelectSingle widget is mandatory","SingleSelectController:isOptionValid");
                this.logger.graph({ name: "UIComponents:SingleSelectController:isOptionValid:el"});
                return false;
            }

            return true;
        },

        /**
         * Initialize the different objects used in the controller such as views, collections, etc...
         */
        setObjects : function (options) {
            var that = this;

            this.selectedItems = (typeof options.selectedItems == "undefined" || options.selectedItems == null || options.selectedItems == []) ? [] : options.selectedItems;

            if (this.isOptionValid(options)){
                //vent is used to trigger up through the nested views the selected item id to the controller
                this.vent = new Wreqr.EventAggregator();

                this.singleSelectLayout = new SingleSelectLayout();

                /************* generate title view ***************/

                this.singleSelectTitleModel = new SingleSelectTitleModel({
                    title : options.title,
                    tooltip: _.has(options, "tooltip") ? options.tooltip : ""
                });

                this.singleSelectTitleView = new SingleSelectTitleView({
                    model : this.singleSelectTitleModel
                });

                /************* generate collection view ***************/

                this.categoriesCollection = options.collection;

                this.singleSelectCollectionView = new SingleSelectCollectionView({
                    //collection: singleSelectCategoriesCollection
                    collection : this.categoriesCollection,
                    vent: this.vent,
                    selectedItems: this.selectedItems
                });

                /************* update the selected item ***************/

                    //once item is selected in the SingleSelectItem view, the corresponding id is triggered to the controller with the id
                this.listenTo(this.vent, "set:selection", function (selected) {
                    that.logger.info("SELECTED: " + selected.id,"SingleSelectController:setObjects");
                    $(".category-item-button").removeClass("selected");
                    selected.activeButton.addClass("selected");
                    that.hide(selected.item);
                });
            }
        },

        /**
         * renders the layout
         */
        render : function (options) {
            if (this.isOptionValid(options)){
                this.singleSelectLayout.render();
                this.singleSelectLayout.title.show(this.singleSelectTitleView);
                this.singleSelectLayout.grid.show(this.singleSelectCollectionView);
                $(options.el).html(this.singleSelectLayout.el);
            }
        },

        /**
         * hide the layout and call the onSelect callback method
         */
        hide : function (item) {
            this.options.el.hide();
            try {
                if (this.options.onSelect){
                    this.options.onSelect(item);
                }
            }
            catch (e) {
                this.logger.error("onSelect callback threw an error - type: " + e.name + " msg: " + e.message,"SingleSelectController::hide");
                this.logger.graph({ name: "UIComponents:SingleSelectController:hide:onSelectError"});
            }

        },
        close: function(){
            this.singleSelectLayout.close();
        },
        version : function () {
            this.logger.info("SingleSelectController.js version " + this.version,"SingleSelectController::version");
        }
    });

    return SingleSelectController;
});
